import React from "react";

function Link(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 16 16" fill="currentColor" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.11799 2.46065C9.615 0.963638 12.0421 0.963638 13.5391 2.46065C15.0362 3.95766 15.0362 6.38479 13.5391 7.8818L12.5963 8.82461C12.4011 9.01987 12.0845 9.01987 11.8892 8.82461C11.694 8.62935 11.694 8.31276 11.8892 8.1175L12.832 7.17469C13.9385 6.06821 13.9385 4.27424 12.832 3.16775C11.7255 2.06127 9.93158 2.06127 8.8251 3.16776L7.88229 4.11056C7.68703 4.30583 7.37044 4.30583 7.17518 4.11056C6.97992 3.9153 6.97992 3.59872 7.17518 3.40346L8.11799 2.46065ZM10.687 5.31275C10.8823 5.50801 10.8823 5.82459 10.687 6.01986L6.02036 10.6865C5.8251 10.8818 5.50851 10.8818 5.31325 10.6865C5.11799 10.4913 5.11799 10.1747 5.31325 9.97942L9.97992 5.31275C10.1752 5.11749 10.4918 5.11749 10.687 5.31275ZM4.11105 7.17469C4.30631 7.36996 4.30631 7.68654 4.11105 7.8818L3.16824 8.82461C2.06176 9.9311 2.06176 11.7251 3.16824 12.8315C4.27473 13.938 6.0687 13.938 7.17518 12.8315L8.11799 11.8887C8.31325 11.6935 8.62983 11.6935 8.8251 11.8887C9.02036 12.084 9.02036 12.4006 8.8251 12.5958L7.88229 13.5387C6.38528 15.0357 3.95815 15.0357 2.46114 13.5387C0.964126 12.0416 0.964127 9.61451 2.46114 8.1175L3.40395 7.17469C3.59921 6.97943 3.91579 6.97943 4.11105 7.17469Z"
        fill="#A5A3AE"
      />
    </svg>
  );
}

const MemoLink = React.memo(Link);
export default MemoLink;
